import { HTTP } from '../config/http-common';
import { ROUTE_API } from '../constants/routes';
import { exportResults } from '../utils/index';

export const loginBy365 = async () => exportResults(await HTTP.get(ROUTE_API.LOGIN_BY_MS365));

export const loginBy365Redirect = async (body) =>
    exportResults(await HTTP.post(ROUTE_API.LOGIN_BY_MS365_REDIRECT, body));
